module.exports = __webpack_public_path__ + "media/falco.1cd987b2.wav";